import { CSSProperties } from 'react';

const DEFAULT_STATUS_COLOR = '#64748b';

export function getJobStatusStyle(statusColor?: string | null): CSSProperties {
  const backgroundColor = isHexColor(statusColor) ? statusColor : DEFAULT_STATUS_COLOR;
  const hex = backgroundColor.slice(1);
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;

  return {
    backgroundColor,
    color: brightness > 128 ? '#0f172a' : '#ffffff',
    border: 'none',
  };
}

function isHexColor(value?: string | null): value is string {
  return typeof value === 'string' && /^#[0-9a-fA-F]{6}$/.test(value);
}